<template>
	<div class="scroll-container">
		<div class="fullpage-container" :class="{ blur: openAllGames }">
			<div ref="gameCards" v-fullpage="options" class="fullpage-wp animated fadeIn">
				<div v-for="(pcGame, $index) in pcGameList" :key="'page.pc.' + $index" ref="pcGames" class="page pcgame">
					<lazyImage :src="pcGame.webImages.pcBackground" class="bg" :responsive-widths="[500, 1024]" />
					<div class="game-information">
						<a
							:href="pcGame.links.officialSite && getLocaleString(pcGame.links.officialSite)"
							class="logo"
							target="_blank"
							rel="external"
						>
							<lazyImage :src="pcGame.webImages.pcLogo" class="bg" />
						</a>
						<ul class="game-info list-unstyled list-inline">
							<li>
								{{ $t('main.genre') }}<span>{{ pcGame.genre }}</span>
							</li>
							<li>
								{{ $t('main.publisher') }}<span>{{ pcGame.publisher }}</span>
							</li>
							<li>
								{{ $t('main.developer') }}<span>{{ pcGame.developer }}</span>
							</li>
						</ul>
						<p class="game-desc" v-html="getLocaleString(pcGame.subhead)"></p>
						<a
							v-if="pcGame.links.officialSite"
							class="learn-more"
							:href="getLocaleString(pcGame.links.officialSite)"
							:gamename="pcGame.title"
							gameplatform="pc"
							target="_blank"
							rel="external"
						>
							{{ $t('main.learn-more') }}
							<svgIcon icon-holder-class="icon-arrow" icon-id="icon-page-right" />
						</a>
						<div>
							<div
								v-for="(value, platform) in pcGame.platforms"
								v-if="platform !== 'xbox' && platform !== 'psn' && platform !== 'ios' && platform !== 'android' && value"
								:key="`pc.${platform}`"
							>
								<button v-if="isMobile === false && platform === 'pc'" class="btn" @click="downloadGame(pcGame.productId)">
									<svgIcon icon-holder-class="icon-download" icon-id="icon-download" />
									<span class="btn-title">{{ $t('main.game-download') }}</span>
								</button>
								<a
									v-if="platform === 'steam'"
									class="btn cta-btn"
									:href="pcGame.platforms[platform]"
									:gamename="pcGame.title"
									:gameplatform="platform"
									target="_blank"
									rel="external"
								>
									<svgIcon icon-holder-class="icon-download" :icon-id="`icon-${platform}-dark`" />
									<span class="btn-title">{{ $t(`main.play-on-${platform}`) }}</span>
								</a>
							</div>
						</div>
						<ul
							v-if="pcGame.platforms.ios || pcGame.platforms.android || pcGame.platforms.xbox || pcGame.platforms.psn"
							class="platform-info list-unstyled list-inline"
						>
							<li>
								<span>{{ $t('main.also-available-on') }}</span>
							</li>
							<li
								v-for="(value, platform) in pcGame.platforms"
								v-if="platform !== 'steam' && platform !== 'pc' && value"
								:key="`pc2.${platform}`"
							>
								<a :href="value" :gamename="pcGame.title" :gameplatform="platform">
									<span>{{
										platform === 'pc'
											? 'Nexon Launcher'
											: platform === 'ios'
											? 'iOS'
											: platform === 'psn'
											? 'PSN'
											: platform.charAt(0).toUpperCase() + platform.substring(1)
									}}</span>
								</a>
							</li>
						</ul>
					</div>
				</div>

				<div v-if="isMobile === false && launcherInfo" class="launcher-download page" :class="region">
					<div class="divider"></div>
					<div
						:style="{ backgroundImage: 'url(' + cdnHost + launcherInfo.backgroundImageRight + ')' }"
						class="background right"
					></div>
					<div
						:style="{ backgroundImage: 'url(' + cdnHost + launcherInfo.backgroundImageLeft + ')' }"
						class="background left"
					></div>
					<div class="launcher-information">
						<h4 class="title nexon-font-bold">{{ $t('main.nexon') }} {{ $t('main.launcher-download') }}</h4>
						<h1 class="launcher-download-desc" v-html="getLocaleString(launcherInfo.description)"></h1>
						<button class="btn" @click="downloadGame(10000)">
							<svgIcon icon-holder-class="icon-download" icon-id="icon-download" />
							<span>{{ $t('main.launcher-download') }}</span>
						</button>
						<div class="blank"></div>
					</div>
				</div>

				<div
					v-for="(mobileGame, $index) in mobileGameList"
					:key="'page.mobile.' + $index"
					ref="mobileGames"
					class="page mobilegame"
				>
					<lazyImage :src="mobileGame.webImages.mobileBackground" class="bg" :responsive-widths="[500, 1024]" />
					<div class="game-information">
						<a
							:href="mobileGame.links.officialSite && getLocaleString(mobileGame.links.officialSite)"
							:gamename="mobileGame.title"
							gameplatform="mobile"
							class="logo"
							target="_blank"
							rel="external"
						>
							<lazyImage :src="mobileGame.webImages.mobileLogo" class="bg" />
						</a>
						<ul class="game-info list-unstyled list-inline">
							<li>
								{{ $t('main.genre') }}<span>{{ mobileGame.genre }}</span>
							</li>
							<li>
								{{ $t('main.publisher') }}<span>{{ mobileGame.publisher }}</span>
							</li>
							<li>
								{{ $t('main.developer') }}<span>{{ mobileGame.developer }}</span>
							</li>
						</ul>
						<p class="game-desc" v-html="getLocaleString(mobileGame.subhead)"></p>
						<a
							v-if="mobileGame.links.officialSite"
							class="learn-more"
							:href="getLocaleString(mobileGame.links.officialSite)"
							:gamename="mobileGame.title"
							gameplatform="mobile"
							target="_blank"
							rel="external"
						>
							{{ $t('main.learn-more') }}
							<svgIcon icon-holder-class="icon-arrow" icon-id="icon-page-right" />
						</a>
						<div class="mobile-download-wrapper">
							<a class="mobile-download ios" :href="mobileGame.platforms.ios" :gamename="mobileGame.title" gameplatform="ios">
								<img :src="`${staticHost}images/thirdparty-icons/itunes/itunes-${locale}.svg`" />
							</a>
							<a
								v-if="mobileGame.platforms.android"
								class="mobile-download google"
								:href="mobileGame.platforms.android"
								:gamename="mobileGame.title"
								gameplatform="android"
							>
								<img :src="`${staticHost}images/thirdparty-icons/google-play/google-play-${locale}.png`" />
							</a>
							<!-- temp assign custom button for DragonNest: SEA region, will migrate this into Umbraco if they need more game.-->
							<a
								v-if="mobileGame.title === 'World of Dragon Nest'"
								class="mobile-download nxpay"
								href="https://pay.nxsea.com"
								target="_blank"
								:gamename="mobileGame.title"
							>
								<img :src="`${staticHost}images/thirdparty-icons/nxpay/top-up-sea.png`" />
							</a>
						</div>
						<ul
							v-if="
								mobileGame.platforms.pc ||
									mobileGame.platforms.steam ||
									mobileGame.platforms.xbox ||
									mobileGame.platforms.psn
							"
							class="platform-info list-unstyled list-inline"
						>
							<li>
								<span>{{ $t('main.also-available-on') }}</span>
							</li>
							<li
								v-for="(value, platform) in mobileGame.platforms"
								v-if="platform !== 'ios' && platform !== 'android' && value"
								:key="`mobile.${platform}`"
							>
								<a :href="value" :gamename="mobileGame.title" :gameplatform="platform">
									<span>{{
										platform === 'pc'
											? 'Nexon Launcher'
											: platform === 'psn'
											? 'PSN'
											: platform.charAt(0).toUpperCase() + platform.substring(1)
									}}</span>
								</a>
							</li>
						</ul>
					</div>
				</div>

				<div
					v-for="(consoleGame, $index) in consoleGameList"
					:key="'page.console.' + $index"
					ref="consoleGames"
					class="page consolegame"
				>
					<lazyImage :src="consoleGame.webImages.pcBackground" class="bg" :responsive-widths="[500, 1024]" />
					<div class="game-information">
						<a
							:href="consoleGame.links.officialSite && getLocaleString(consoleGame.links.officialSite)"
							:gamename="consoleGame.title"
							gameplatform="console"
							class="logo"
							target="_blank"
							rel="external"
						>
							<lazyImage :src="consoleGame.webImages.pcLogo" class="bg" />
						</a>
						<ul class="game-info list-unstyled list-inline">
							<li>
								{{ $t('main.genre') }}<span>{{ consoleGame.genre }}</span>
							</li>
							<li>
								{{ $t('main.publisher') }}<span>{{ consoleGame.publisher }}</span>
							</li>
							<li>
								{{ $t('main.developer') }}<span>{{ consoleGame.developer }}</span>
							</li>
						</ul>
						<p class="game-desc" v-html="getLocaleString(consoleGame.subhead)"></p>
						<a
							v-if="consoleGame.links.officialSite"
							class="learn-more"
							:href="getLocaleString(consoleGame.links.officialSite)"
							:gamename="consoleGame.title"
							gameplatform="console"
							target="_blank"
							rel="external"
						>
							{{ $t('main.learn-more') }}
							<svgIcon icon-holder-class="icon-arrow" icon-id="icon-page-right" />
						</a>
						<div>
							<div
								v-for="(value, platform) in consoleGame.platforms"
								v-if="platform !== 'pc' && platform !== 'steam' && platform !== 'ios' && platform !== 'android' && value"
								:key="`consoleGame.${platform}`"
							>
								<a
									class="btn cta-btn"
									:href="consoleGame.platforms[platform]"
									:gamename="consoleGame.title"
									:gameplatform="platform"
									target="_blank"
									rel="external"
								>
									<svgIcon icon-holder-class="icon-download" :icon-id="`icon-${platform}-dark`" />
									<span class="btn-title">{{ $t(`main.play-on-${platform}`) }}</span>
								</a>
							</div>
						</div>
						<ul
							v-if="
								consoleGame.platforms.pc ||
									consoleGame.platforms.steam ||
									consoleGame.platforms.ios ||
									consoleGame.platforms.android
							"
							class="platform-info list-unstyled list-inline"
						>
							<li>
								<span>{{ $t('main.also-available-on') }}</span>
							</li>
							<li
								v-for="(value, platform) in consoleGame.platforms"
								v-if="platform !== 'xbox' && platform !== 'psn' && value"
								:key="`consoleGame2.${platform}`"
							>
								<a :href="value" :gamename="consoleGame.title" :gameplatform="platform">
									<span>{{
										platform === 'pc'
											? 'Nexon Launcher'
											: platform === 'ios'
											? 'iOS'
											: platform.charAt(0).toUpperCase() + platform.substring(1)
									}}</span>
								</a>
							</li>
						</ul>
					</div>
				</div>
				<div class="empty"><!-- this is last fullpage item for moving up footer --></div>
			</div>
		</div>

		<div v-if="allGameList.length > 0" ref="gamesNav" class="game-list-navigation" :class="{ 'move-up': naviMoveUp }">
			<div v-if="!hidePlatformButton" class="select-game-type radio form-group">
				<label
					v-for="(value, platform) in inViewport"
					:id="`${platform}Games`"
					:key="`all.${platform}`"
					:class="{ active: checkViewport(platform), adjust: consoleGameList.length > 0 }"
					@click="movePlatforms(platform)"
				>
					<input type="radio" name="optionsRadios" :checked="checkViewport(platform)" />
					<span class="input-radio"></span>
					{{ $t(`main.${platform}-games`) }}
				</label>
			</div>

			<gameListNavigation :all-game-list="allGameList" :list-index="listIndex" @moveTo="moveTo"> </gameListNavigation>

			<div class="all-games">
				<div class="icon">
					<a :class="{ active: openAllGames }" @click="toggleAllGames">
						<svgIcon icon-holder-class="icon-all-game" icon-id="icon-all-game" />
						{{ $t('main.all-games') }}
					</a>
				</div>
			</div>
			<div class="clearfix"></div>
		</div>

		<!-- modal open game list-->
		<div class="modal open-all-games animated fadeIn" :class="{ active: openAllGames }" @click="toggleAllGames">
			<a>
				<svgIcon icon-holder-class="icon-close" icon-id="icon-close" />
			</a>
			<div v-if="pcGameList.length > 0" class="pc-games">
				<h4>{{ $t('main.pc-games') }}</h4>
				<ul class="list-unstyled list-inline">
					<li v-for="(pcGame, $index) in pcGameList" :key="'all.pc.' + $index" :class="{ active: listIndex === $index }">
						<a target="_blank" rel="external" @click="moveTo($index)">
							<div class="banner" :style="{ backgroundImage: `url(${cdnHost}${pcGame.webImages.pcThumbnail})` }">
								<div
									class="hover"
									:style="{ backgroundImage: `url(${cdnHost}${pcGame.webImages.pcThumbnailHoverLogo})` }"
									:class="{ focusImage: listIndex === $index }"
								></div>
							</div>
							<span class="banner-title" :class="{ focusTitle: listIndex === $index }">{{ pcGame.title }}</span>
						</a>
					</li>
				</ul>
			</div>
			<div v-if="mobileGameList.length > 0" class="mobile-games">
				<h4>{{ $t('main.mobile-games') }}</h4>
				<ul class="list-unstyled list-inline">
					<li
						v-for="(mobileGame, $index) in mobileGameList"
						:key="'all.mobile.' + $index"
						:class="{ active: listIndex === pcGameList.length + $index }"
					>
						<a target="_blank" rel="external" @click="moveTo(pcGameList.length + $index)">
							<div class="banner" :style="{ backgroundImage: `url(${cdnHost}${mobileGame.webImages.mobileThumbnail})` }">
								<div
									class="hover"
									:style="{ backgroundImage: `url(${cdnHost}${mobileGame.webImages.mobileThumbnailHoverLogo})` }"
									:class="{ focusImage: listIndex === pcGameList.length + $index }"
								></div>
							</div>
							<span class="banner-title" :class="{ focusTitle: listIndex === pcGameList.length + $index }">{{
								mobileGame.title
							}}</span>
						</a>
					</li>
				</ul>
			</div>
			<div v-if="consoleGameList.length > 0" class="console-games">
				<h4>{{ $t(`main.console-games`) }}</h4>
				<ul class="list-unstyled list-inline">
					<li
						v-for="(consoleGame, $index) in consoleGameList"
						:key="'all.pc.' + $index"
						:class="{ active: listIndex === pcGameList.length + mobileGameList.length + $index }"
					>
						<a target="_blank" rel="external" @click="moveTo(pcGameList.length + mobileGameList.length + $index)">
							<div class="banner" :style="{ backgroundImage: `url(${cdnHost}${consoleGame.webImages.pcThumbnail})` }">
								<div
									class="hover"
									:style="{ backgroundImage: `url(${cdnHost}${consoleGame.webImages.pcThumbnailHoverLogo})` }"
									:class="{ focusImage: listIndex === pcGameList.length + mobileGameList.length + $index }"
								></div>
							</div>
							<span
								class="banner-title"
								:class="{ focusTitle: listIndex === pcGameList.length + mobileGameList.length + $index }"
								>{{ consoleGame.title }}</span
							>
						</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
// polyfills
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/object-fit/ls.object-fit';

import { locale, LauncherDownloadHost } from '../config/config-cdn';
import gameListNavigation from './game-list-navi';
import lazyImage from './lazy-image';

export default {
	name: 'ArenaHome',
	components: {
		svgIcon,
		gameListNavigation,
		lazyImage,
	},
	data() {
		return {
			options: {
				start: 0,
				dir: 'v',
				loop: false,
				duration: 100,
				der: 0.1,
				overflow: scroll,
				beforeChange: (ele, current, next) => {
					if (!this.fullpageMode) return;
					this.moveUp = this.$refs.gameCards.childElementCount - 1 === next; // if it's last index one
					if (next === this.pcGameList.length) return;
					if (next > this.pcGameList.length) next--;
					this.setListIndex(next);
				},
			},
			listIndex: 0,
			moveUp: false,
			pcGamesChecked: true,
			mobileGamesChecked: false,
			openAllGames: false,
			leftArrow: false,
			rightArrow: false,
			pcGameList: [],
			mobileGameList: [],
			consoleGameList: [],
			launcherInfo: false,
			fullpageMode: true,
			inViewport: { pc: true, mobile: false, console: false },
			previousHeight: null,
			previousWidth: null,
		};
	},
	computed: {
		region() {
			return environment.region || 'global';
		},
		allGameList() {
			return this.pcGameList
				.map((x) => {
					x.type = 'pc';
					return x;
				})
				.concat(
					this.mobileGameList.map((x) => {
						x.type = 'mobile';
						return x;
					}),
					this.consoleGameList.map((x) => {
						x.type = 'console';
						return x;
					})
				);
		},
		isMobile() {
			return /(iPhone|iPad|Android)/gi.test(navigator.userAgent);
		},
		naviMoveUp() {
			return this.moveUp;
		},
		hidePlatformButton() {
			const pcList = this.pcGameList.length === 0,
				mobileList = this.mobileGameList.length === 0,
				consoleList = this.consoleGameList.length === 0;

			if ([pcList, mobileList, consoleList].filter(Boolean).length > 1) {
				return true;
			}
			return false;
		},
	},
	watch: {
		moveUp(value) {
			const footer = document.getElementById('globalFooter');
			if (value) {
				footer.classList.add('move-up');
				window.Footer.$emit('onFooterMoveUp', true);
			} else {
				footer.classList.remove('move-up');
				window.Footer.$emit('onFooterMoveUp', false);
			}
		},
		fullpageMode(value) {
			if (value) {
				this.$nextTick(() => {
					this.$refs.gameCards.$fullpage.moveTo(0);
				});
			}
		},
	},
	created() {
		this.handleFooterEvent();
		this.fullpageMode = window.innerWidth > 1024;
		Promise.all([this.$cdnAPI.getGameList(), this.$cdnAPI.getFrontendConfig()]).then(([gameList, launcherInfo]) => {
			this.pcGameList = gameList.filter((x) => x.showInAllGamesPage && (x.platforms.pc || x.platforms.steam));
			this.mobileGameList = gameList.filter((x) => x.showInAllGamesPage && (x.platforms.ios || x.platforms.android));
			this.consoleGameList = gameList.filter((x) => x.showInAllGamesPage && (x.platforms.xbox || x.platforms.psn));

			if (this.mobileGameList.length === 0) delete this.inViewport.mobile;
			if (this.consoleGameList.length === 0) delete this.inViewport.console;

			this.launcherInfo = launcherInfo.launcherDownloadPage;
			this.$nextTick(() => {
				window.addEventListener('scroll', this.handleScroll);
				window.addEventListener('scroll', this.handleInViewport);
				window.addEventListener('resize', this.handleResize);
				this.$refs.gameCards.$fullpage.update();
			});
		});
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
		window.removeEventListener('scroll', this.handleInViewport);
		window.removeEventListener('resize', this.handleResize);
	},
	methods: {
		handleScroll() {
			if (this.$refs.gameCards.offsetHeight + 100 > window.innerHeight + window.pageYOffset) {
				this.$refs.gamesNav.classList.remove('sticky');
			} else {
				this.$refs.gamesNav.classList.add('sticky');
			}
		},
		handleResize() {
			this.fullpageMode = window.innerWidth > 1024;

			// Go to top when height of the page changes.
			const height = this.getWindowSize('height')[0],
				width = this.getWindowSize('width')[0];
			if (height !== this.previousHeight) {
				this.previousHeight = height;
				this.movePCGames();
			}
			if (width !== this.previousWidth) {
				this.previousWidth = width;
				this.movePCGames();
				this.inViewport.pc = true;
				this.listIndex = 0;
			}
		},
		handleInViewport() {
			if (this.fullpageMode) return;
			const divHeight = document.getElementsByClassName('page')[0].offsetHeight,
				platforms = Object.keys(this.inViewport),
				offsetCustom = { pc: 0, mobile: this.consoleGameList.length > 0 ? 0 : 3, console: 3 };
			for (let i = 0; i < platforms.length; i += 1) {
				const platform = platforms[i],
					gameLength = document.querySelectorAll(`.${platform}game`).length,
					game = document.querySelector(`.${platform}game`);

				if (!game) continue;
				const bound = game.getBoundingClientRect();
				if (
					bound.top >=
						0 +
							(-divHeight * (gameLength + offsetCustom[platform]) +
								(window.innerHeight || document.documentElement.clientHeight)) &&
					bound.left >= 0 &&
					bound.right <= (window.innerWidth || document.documentElement.clientWidth) &&
					bound.bottom <= (window.innerHeight || document.documentElement.clientHeight)
				) {
					this.inViewport[platform] = true;
				} else {
					this.inViewport[platform] = false;
				}
			}
		},
		checkViewport(platform) {
			let currViewport;
			if (this.fullpageMode) {
				currViewport = this.allGameList[this.listIndex] && this.allGameList[this.listIndex].type === platform;
			} else {
				currViewport = this.inViewport[platform];
			}
			return currViewport;
		},
		handleFooterEvent() {
			window.Footer.$on('moveUpToogle', () => {
				this.moveUp = !this.moveUp;
			});
		},
		getLocaleString(data) {
			if (!data) return '';
			return data[locale[this.locale]] || data[Object.keys(data)[0]];
		},
		getWindowSize(dimension) {
			// dimension must be in string.
			return window
				.getComputedStyle(document.getElementById('body'), null)
				.getPropertyValue(dimension)
				.split('px', 1);
		},
		toggleAllGames() {
			this.openAllGames = !this.openAllGames;
			if (this.openAllGames) {
				document.getElementsByClassName('game-list-navigation')[0].style.display = 'none';
			} else {
				document.getElementsByClassName('game-list-navigation')[0].style.display = 'block';
			}
		},
		moveTo(index) {
			// eslint-disable-next-line
				if (index >= this.pcGameList.length) index++;
			this.$refs.gameCards.$fullpage.moveTo(index, true);
		},
		movePlatforms(platform) {
			if (platform === 'pc') return this.movePCGames();
			if (platform === 'mobile') return this.moveMobileGames();
			if (platform === 'console') return this.moveConsoleGames();
			return null;
		},
		movePCGames() {
			const width = this.getWindowSize('width');
			if (width < 1024) {
				window.scrollTo(0, 0);
			} else {
				this.moveTo(this.allGameList.findIndex((el) => el.type === 'pc'));
			}
		},
		moveMobileGames() {
			const width = this.getWindowSize('width');
			if (width < 1024) {
				window.scrollTo(0, this.$refs.mobileGames[0].offsetTop);
			} else {
				this.moveTo(this.allGameList.findIndex((el) => el.type === 'mobile'));
			}
		},
		moveConsoleGames() {
			const width = this.getWindowSize('width');
			if (width < 1024) {
				window.scrollTo(0, this.$refs.consoleGames[0].offsetTop);
			} else {
				this.moveTo(this.allGameList.findIndex((el) => el.type === 'console'));
			}
		},
		setListIndex(index) {
			this.listIndex = index;
		},
		downloadGame(prodId) {
			const getLauncherType = () => {
					if (this.region === 'global') {
						return '';
					}
					return `_${this.region.toUpperCase()}`;
				},
				launcherType = getLauncherType(),
				productId = prodId,
				partnerKey = this.$route.query.partnerkey,
				base = new URL(LauncherDownloadHost[process.env.NODE_ENV]);

			base.searchParams.set('file', `NexonLauncherSetup${launcherType}.exe`);
			try {
				// Firefox private mode doesn't support window.ga.getAll function
				base.searchParams.set('client-id', window.ga.getAll()[0].get('clientId'));
				// eslint-disable-next-line
				} catch (e) {}
			if (productId) {
				base.searchParams.set('product-id', productId);
			}
			if (partnerKey) {
				base.searchParams.set('partnerkey', partnerKey);
			}
			window.location = base.href;
		},
	},
};
</script>

<style lang="less">
.scroll-container {
	width: 100%;
	height: 100%;
}

.fullpage-container {
	position: absolute;
	left: 0;
	top: 80px;
	width: 100%;
	height: 900px;
	&.blur {
		filter: blur(4px);
	}
	.fullpage-wp {
		&.anim {
			transition: 0.2s;
		}
	}
}
.page {
	// background-size: cover;
	position: relative;
	width: 100%;
	height: 100%;
	> .bg > img {
		object-fit: cover;
		font-family: 'object-fit: cover';
		transition: 0.7s;
		top: 10px;
	}
	&.active {
		> .bg > img {
			top: -10px;
		}
	}
	&.launcher-download {
		.launcher-information {
			top: 45%;
			width: 50%;
			margin: 0 auto;
			text-align: center;
			transform: translateY(-50%);
			padding: 0px;
			.btn {
				margin: 0 auto;
				margin-top: 85px;
			}
		}
		.divider {
			height: 10px;
			background-color: #000;
			margin-bottom: 30px;
		}
		background-size: initial;
		background-color: #ededed;
		background-position: right center;
		.blank {
			height: 80px;
			width: 100%;
		}
		> .background {
			&.right {
				left: ~'calc(50% + 455px + 60px)';
				background-position: left bottom;
			}
			&.left {
				right: ~'calc(50% + 455px + 60px)';
				background-position: right bottom;
			}
			position: absolute;
			bottom: 0;
			margin-bottom: 140px;
			width: ~'calc(25% - 60px)';
			max-width: 550px;
			height: 100%;
			background-size: contain;
			background-repeat: no-repeat;
		}
		h4 {
			&.title {
				margin: 0 auto;
				font-size: 18px;
				width: 400px;
				letter-spacing: 0.3em;
				text-transform: uppercase;
				line-height: 1.5em;
			}
		}
		h1 {
			&.launcher-download-desc {
				max-width: 910px;
				margin: 0 auto;
				margin-top: 30px;
				font-size: 40px;
				color: #666;
				span {
					color: #00b5a6;
				}
				text-shadow: -1px -1px 2px #ededed, 1px -1px 2px #ededed, -1px 1px 2px #ededed, 1px 1px 2px #ededed;
			}
		}
	}
}

.game-information,
.launcher-information {
	position: relative;
	padding-top: 80px;
	padding-left: 60px;
	.logo {
		position: relative;
		width: 420px;
		height: 18vh;
		display: block;
		> .bg > img {
			object-fit: contain;
			object-position: left 50%;
			font-family: 'object-fit: contain';
		}
		> img {
			background-position: left 50% !important;
		}
	}
	.game-info {
		color: #adadad;
		font-size: 14px;
		text-shadow: 0 0 1px rgba(0, 0, 0, 0.5);
		span {
			color: #fff;
			margin-left: 5px;
		}
		& > li + li:before {
			color: #adadad;
			text-shadow: 0 0 1px rgba(0, 0, 0, 0.5);
			padding: 0 10px 0 0;
			content: '|\A0';
			font-size: 11px;
			position: relative;
			top: -2px;
		}
	}
	.platform-info {
		margin: 0;
		padding-top: 15px;
		line-height: 0;
		color: #adadad;
		text-shadow: 0 0 1px rgba(0, 0, 0, 0.5);
		a {
			span {
				color: #adadad;
				font-size: 14px;
				text-decoration: underline;
				cursor: pointer;
				text-shadow: 0 0 1px rgba(0, 0, 0, 0.5);
			}
			:hover {
				color: #ffffff;
			}
		}
		& > li:first-child {
			padding-right: 0px;
		}
		& > li:not(:first-child) {
			position: relative;
			padding: 0 2px 0 2px;
		}
		& > li + li:not(:last-child):after {
			content: '\002C';
		}
	}

	.game-desc {
		color: fade(#fff, 75%);
		text-shadow: 0 0 1px rgba(0, 0, 0, 0.85);
		font-size: 16px;
		width: 550px;
	}

	.learn-more {
		font-size: 12px;
		font-weight: bold;
		text-transform: uppercase;
		color: fade(#fff, 85%);
		text-shadow: 0 0 1px rgba(0, 0, 0, 0.85);
		margin-top: 30px;
		display: inline-block;
		.icon-arrow {
			width: 15px;
			height: 9px;
			opacity: 0.85;
		}
		&:hover {
			color: fade(#fff, 100%);
			icon-arrow {
				opacity: 0.9;
			}
		}
	}
	button,
	a {
		span {
			display: inline-block;
			margin-top: 8px;
		}
		.icon-download {
			width: 20px;
			height: 27px;
			vertical-align: middle;
			margin-right: 5px;
		}
		&.btn {
			margin-top: 60px;
			color: #000;
			background-color: #fff;
			background-size: 0 100%;
			border: none;
			border-radius: 25px;
			padding: 10px 30px;
			text-transform: uppercase;
			transition: background-color 0.5s;
			display: block;
			&.cta-btn {
				padding: 10px 25px 10px 20px;
				display: inline-block;
				.icon-download {
					width: 30px;
					height: 30px;
					margin-right: 10px;
				}
				span {
					position: relative;
					top: 2px;
				}
			}
		}
		&.btn:hover {
			background-color: #00ffd4;
			background-image: linear-gradient(to right, rgba(0, 255, 212, 0.5) 100%, rgba(0, 255, 170, 1) 80%);
			background-repeat: no-repeat;
			background-size: 200% 100%;
			transition: background-size 1s, background-color 1s;
		}
		&.btn:active {
			background-color: #15ffd6;
			transition: background-size 0s;
		}
	}
	.mobile-download-wrapper {
		margin-top: 60px;

		.mobile-download {
			height: 50px;
			display: inline-block;
			margin-right: 20px;
			&.google {
				margin-right: 0;
			}
			img {
				height: 50px;
			}
		}
	}
	.nxpay {
		height: 50px;
		// margin-top: 10px;
		margin-left: 20px;
		display: inline-block;
		img {
			height: 50px;
		}
	}
}

.game-list-navigation {
	background-color: #1a1a1a;
	position: fixed;
	bottom: 40px;
	transition: 0.2s;
	height: 100px;
	width: 100%;
	&.move-up {
		bottom: 201px;
		transition: 0.2s;
	}
	.select-game-type {
		padding-left: 60px;
		position: absolute;
		margin: 0;
		top: 50%;
		left: 0;
		transform: translate(0%, -50%);
		.input-radio {
			width: 9px;
			height: 9px;
			top: 0;
			background-color: #000 !important;
			margin-right: 15px;
			&:after {
				top: 0;
				left: 0;
				width: 9px;
				height: 9px;
				box-shadow: 0 0 10px #fff, 0 0 10px #fff;
			}
		}
		label {
			display: block;
			color: fade(#fff, 40%);
			font-size: 12px;
			font-weight: bold;
			text-transform: uppercase;
			margin: 10px 0;
			line-height: normal;
			transition: color 0.3s;
			&:hover,
			&.active {
				color: fade(#fff, 100%);
			}
		}
	}
	.icon-previews,
	.icon-next {
		background-color: #1a1a1a;
		position: absolute;
		height: 100px;
		width: 45px;
		padding: 40px 15px 0;
		cursor: pointer;
		z-index: 1;
		.icon-nav {
			height: 16px;
			width: 15px;
			opacity: 0.5;
			transition: opacity 0.3s;
		}
		&:hover {
			opacity: 1;
			.icon-nav {
				opacity: 1;
			}
		}
	}
	.icon-previews {
		left: 0;
	}
	.icon-next {
		right: 0;
	}
	.game-list-wrapper {
		width: 720px;
		padding: 0 40px;
		position: relative;
		height: 100px;
		margin: 0 auto;

		.game-list-window {
			width: 640px;
			height: 100px;
			overflow: hidden;
			position: absolute;
		}

		.game-list {
			position: absolute;
			white-space: nowrap;
			left: 0;
			transition: left 0.5s;
			/*margin-left: 45px;*/
			li {
				display: inline-block;
				width: 128px;
				cursor: pointer;
				color: fade(#fff, 40%);
				vertical-align: top;
				height: 100px;
				transition: color 0.3s;
				&:hover {
					color: fade(#fff, 100%);
					.icon {
						opacity: 1;
					}
				}
				&.active {
					color: fade(#fff, 100%);
					background-color: #121212;
					background: url('~@/images/icons/icon-bg.png') no-repeat top center;
					.icon {
						opacity: 1;
					}
				}
				span {
					white-space: pre-wrap;
					display: block;
					margin-top: 7px;
					font-size: 12px;
					line-height: 1.2em;
					height: 28px;
					text-align: center;
				}
			}
			.icon {
				background-position: center -16px;
				width: 44px;
				height: 44px;
				margin: 0 auto;
				margin-top: 15px;
				opacity: 0.3;
			}
		}
	}
	.all-games {
		position: absolute;
		right: 0;
		top: 50%;
		transform: translate(0%, -50%);
		cursor: pointer;
		.icon {
			display: inline-block;
			width: 160px;
			text-align: center;
		}
		a {
			.icon-all-game {
				width: 21px;
				height: 21px;
				display: block;
				margin: 0 auto 10px;
			}
			display: inline-block;
			color: #fff;
			opacity: 0.5;
			transition: opacity 0.3s;
			&:hover,
			&.active {
				opacity: 1;
				.icon-all-game {
					box-shadow: 0 0 30px rgba(255, 255, 255, 0.4), 0 0 30px rgba(255, 255, 255, 0.4);
				}
			}
		}
	}
}
.open-all-games {
	margin: 0 0 40px;
	padding: 25px 45px;
	background-color: rgba(0, 0, 0, 0.9);
	overflow-y: auto;
	&::-webkit-scrollbar {
		width: 8px;
	}
	&::-webkit-scrollbar-track {
		background: transparent;
	}
	&::-webkit-scrollbar-thumb {
		background: #737373;
		border-radius: 1px;
	}
	a {
		cursor: pointer;
		.icon-close {
			position: absolute;
			width: 22px;
			height: 22px;
			right: 30px;
			top: 30px;
			z-index: 101;
			opacity: 0.8;
			&:hover {
				opacity: 1;
			}
		}
	}
	h4 {
		font-size: 18px;
		font-weight: bold;
		letter-spacing: 0.3em;
		text-transform: uppercase;
		line-height: 1.5em;
		color: #fff;
		margin-left: 15px;
	}
	&.animated {
		animation-duration: 0.2s;
	}
	&.modal {
		display: none;
	}
	&.active {
		display: block;
	}

	span {
		color: fade(#fff, 70%);
		display: inline-block;
		margin: 15px 0 20px;
		transition: 0.3s;
		font-size: 16px;
		:hover {
			span {
				color: fade(#fff, 100%);
			}
		}
	}
	.pc-games,
	.console-games {
		ul {
			margin-left: 0;
			li {
				margin: 20px 10px 0;
				transition: 0.3s;
				vertical-align: top;
				.banner {
					width: 330px;
					height: 140px;
					&:hover {
						outline-style: solid;
						outline-color: white;
						outline-width: 5px;
						background-repeat: no-repeat;
						background-size: cover;
						transform: scale(1.05, 1.05);
						transition-duration: 0.2s;
						~ .banner-title {
							color: #ffffff;
						}
					}
					.focusImage {
						display: block;
					}
				}
				.hover {
					width: 330px;
					height: 140px;
					display: none;
				}
				:focus {
					.hover {
						border: 5px solid #fff;
						transition: border 0.3s;
						background: none;
					}
				}
				.focusTitle {
					color: #ffffff;
				}
			}
		}
	}
	.mobile-games {
		ul {
			margin-left: -10px;
			li {
				margin: 20px 20px 0;
				transition: 0.3s;
				width: 135px;
				vertical-align: top;
				.banner {
					width: 125px;
					height: 125px;
					&:hover {
						outline-style: solid;
						outline-color: white;
						outline-width: 5px;
						background-repeat: no-repeat;
						background-size: cover;
						transform: scale(1.05, 1.05);
						transition-duration: 0.2s;
						~ .banner-title {
							color: #ffffff;
						}
					}
					.focusImage {
						display: block;
					}
				}
				.hover {
					width: 125px;
					height: 125px;
					display: none;
				}
				:focus {
					.hover {
						border: 5px solid #fff;
						transition: border 0.3s;
					}
				}
				.focusTitle {
					color: #ffffff;
				}
				span {
					display: inline-block;
					text-align: center;
					width: 100%;
				}
			}
		}
	}
}

@media (max-width: 1920px) {
	.page {
		&.launcher-download {
			.launcher-information {
				.btn {
					margin-top: 75px;
				}
			}
			> .background {
				&.right {
					left: ~'calc(75% + 60px)';
				}
				&.left {
					right: ~'calc(75% + 60px)';
				}
				width: ~'calc(33% - 60px)';
			}
		}
	}
	.game-information {
		> div {
			display: flex;
			> div:last-child {
				.btn {
					margin-right: 0px;
				}
			}
			.btn {
				margin-right: 20px;
			}
		}
	}
}
@media (max-width: 1400px) {
	.page {
		&.launcher-download {
			h1 {
				&.launcher-download-desc {
					font-size: 34px;
				}
			}
			> .background {
				width: ~'calc(35% - 60px)';
				max-width: 450px;
			}
		}
	}
}
@media (min-height: 1200px) {
	.fullpage-container {
		.game-information {
			padding-top: 230px;
			zoom: 1.2;
		}
	}
}
@media (max-height: 1200px) {
	.fullpage-container {
		top: 0;
		height: 100% !important;
	}
}
@media (min-height: 1150px) {
	.fullpage-container {
		height: 100% !important;
		top: 0;
		.game-information {
			padding-top: 250px;
		}
	}
}
@media (max-width: 1100px) {
	.game-list-navigation {
		.select-game-type {
			padding-left: 30px;
			z-index: 2;
		}
	}
}
@media (max-width: 1024px) {
	#globalNavigation {
		position: fixed;
		top: 0;
		width: 100%;
		z-index: 1200;
		.open-list {
			&.active {
				position: relative;
			}
			.icon-close {
				top: 30px;
			}
			.launcher-section {
				height: auto;
			}
		}
	}
	.fullpage-container {
		position: relative;
		top: 50px !important;
		height: 100%;

		.fullpage-wp {
			transform: none !important;
		}
	}
	.page {
		height: 420px !important;
		top: 0;
		opacity: 1;
		> .bg > img {
			object-fit: contain;
			object-position: right 10px;
			font-family: 'object-fit: contain; object-position: right 10px;';
		}

		&.launcher-download {
			.divider {
				margin-bottom: 0;
			}
			> .background {
				display: none;
				/*top: 20px;*/
				/*height: ~"calc(100% - 20px)";*/
			}
			.launcher-information {
				position: absolute;
				padding: 0;
				top: 50%;
				width: 100%;
				// margin-top: -102px;
				margin: 0;
				text-align: center;
				transform: translateY(-50%);
				/*text-align: left;*/
				.blank {
					height: 0px;
				}
				h1 {
					font-family: Arial, sans-serif, 'Helvetica Neue', Helvetica;
					font-size: 14px;
					width: 100%;
					max-width: 480px;
					padding: 10px 20px 0;
					margin: auto;
				}
				h4 {
					width: 300px;
					margin: auto;
				}
				.btn {
					margin: 40px auto 0;
				}
			}
		}
		.game-information {
			text-align: left;
			padding-top: 20px !important;
			padding-left: 40px;
			.logo {
				display: block;
				padding: 0;
				width: 150px;
				height: 100px;
				> .bg > img {
					object-position: 50% 50%;
				}
				> img {
					background-position: 50% 50% !important;
				}
			}
			.game-info,
			.game-desc {
				display: none;
			}
			.learn-more {
				margin: 0 auto;
				padding-top: 20px;
				text-shadow: 0 0 5px rgba(0, 0, 0, 0.85);
				display: block;
			}
			.btn {
				margin-top: 27px !important;
			}
			.mobile-download-wrapper {
				margin-top: 30px;
				display: inline-block;
			}
			> div {
				align-items: left;
				justify-content: left;
			}
			.platform-info {
				padding-top: 10px;
			}
			.nxpay {
				margin-top: 10px;
				margin-left: 0;
				display: block;
			}
		}
	}
	.game-list-navigation {
		height: 60px;
		bottom: 0;
		transition: none;
		&.move-up {
			bottom: 0;
			transition: none;
		}
		&.sticky {
			bottom: -50px;
			position: relative;
		}
		.game-list-wrapper,
		.all-games {
			display: none;
		}
		.select-game-type {
			width: 100%;
			padding: 0;
			margin: 0;
		}
		#pcGames,
		#mobileGames,
		#consoleGames {
			display: inline-block;
			width: 49%;
			padding: 0;
			text-align: center;
			margin: 20px 0;
		}
		#pcGames {
			border-right: 1px solid #262626;
		}
		#mobileGames {
			border-right: 1px solid #262626;
		}
		.adjust {
			width: 32% !important;
		}
		// .move-pc {
		// 	display: inline-block;
		// 	width: 49%;
		// 	height: 60px;
		// 	position: absolute;
		// 	top: 0;
		// 	left: 0;
		// }
		// .move-mobile {
		// 	display: inline-block;
		// 	width: 49%;
		// 	height: 60px;
		// 	position: absolute;
		// 	top: 0;
		// 	right: 0;
		// }
	}
	#globalFooter {
		position: relative !important;
		top: 0;
	}
}
@media (max-height: 980px) {
	.fullpage-container {
		height: 100% !important;
		top: 0;
		.page {
			// top: -10px;
			.game-information {
				padding-top: 80px;
				.btn {
					margin-top: 40px;
				}
			}
		}
		.launcher-download {
			.game-information {
				padding-top: 80px;
			}
		}
	}
}
@media (max-width: 768px) {
	.page {
		height: 315px !important;
		&.launcher-download {
			.launcher-information {
				padding: 15px 20px 0;
				.btn {
					margin-top: 40px;
				}
			}
		}
		.game-information {
			.learn-more {
				padding-top: 10px;
			}
			.platform-info {
				> li:first-child {
					display: none;
				}
			}
		}
	}
}
@media (max-height: 610px) and (min-width: 1025px) {
	.fullpage-container {
		position: relative;
		top: 50px !important;
		height: 100%;
		.fullpage-wp {
			transform: none !important;
		}
		.page {
			&.active {
				> .bg > img {
					object-position: center 10px;
					font-family: 'object-position: center 10px';
					transition: none;
				}
			}
			.game-information {
				padding-top: 50px;
			}
		}
		.launcher-download {
			.title {
				padding-top: 40px;
			}
			.game-information {
				padding-top: 40px;
			}
		}
	}
	.page {
		height: 520px !important;
		opacity: 1;
		&.launcher-download {
			> .background {
				margin-bottom: 0px;
			}
		}
	}
	.game-list-navigation {
		display: none;
	}
}
@media (max-width: 530px) {
	.page {
		> .bg > img {
			object-fit: cover;
			font-family: 'object-fit: cover';
		}
		.cta-btn {
			.btn-title {
				display: none;
			}
		}
	}
}

@media (max-width: 480px) {
	.page {
		height: 250px !important;
		&.launcher-download {
			.divider {
				margin-bottom: 0;
			}
			.launcher-information {
				.btn {
					margin-top: 20px;
				}
			}
		}
		.game-information {
			padding-left: 20px;
			.logo {
				display: block;
				padding: 0;
				width: 120px;
				height: 70px;
				> .bg > img {
					object-position: 50% 50%;
				}
				> img {
					background-position: 50% 50% !important;
				}
			}
			.btn {
				margin-top: 20px !important;
				padding: 10px 15px;

				&.cta-btn {
					padding: 10px;
					.icon-download {
						margin-right: 0;
					}
					.btn-title {
						display: none;
					}
				}
			}
			.mobile-download-wrapper {
				margin-top: 20px;
				.mobile-download {
					margin-right: 5px;
					img {
						height: 40px;
					}
				}
			}
		}
	}
	.game-list-navigation {
		min-width: 326px;
		.select-game-type {
			.input-radio {
				display: block;
				margin: 0 auto 7px auto;
			}
		}
	}
}
</style>
